(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* Wrapped in an IIFE deliberately. Shopify concatenates every section's
     javascript block into one shared global scope, so a top-level `const`
     here collides with an identically-named declaration in any other
     section — and a duplicate `const` is a SyntaxError that takes down the
     whole bundle, not just this section. Nothing here needs to be global. */
  (function () {
    const url = new URL(window.location.href);
    if (url.hash) {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          const card = document.getElementById(url.hash.slice(1));
          if (card) {
            card.scrollIntoView({ behavior: 'instant' });
          }
        },
        { once: true }
      );
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-cross-sell"]) return;
  try {
    
  /**
   * Cross-sell turntable playback.
   *
   * Deliberately a separate, smaller implementation from the one in
   * `mv-product-card-styles`: that script is delegated because predictive
   * search injects cards after load, and it owns the `.mv-card--video` class.
   * This section renders exactly one card, is never injected, and does not
   * render that snippet — the product template has no product cards on it at
   * all — so there is nothing to share and nothing to collide with.
   *
   * Contract, matching the product card's:
   *   - `prefers-reduced-motion: reduce` never plays. The poster is the card.
   *     Read live rather than once at parse time, so a visitor who turns the
   *     preference on mid-session is not left with a looping video.
   *   - Fine pointer: play while the cursor is on the card.
   *   - Coarse pointer: play while at least 60% of the card is in view.
   *   - A hidden tab pauses; returning re-observes, because an
   *     IntersectionObserver does not re-fire without a geometry change.
   *   - The markup already works with no javascript: the poster is painted by
   *     its own <img> (and by the video element's attribute behind it), so a
   *     parse failure leaves a still card rather than a hole.
   *   - `.mv-cross__poster` is retired by `is-live`, which is set from a
   *     DECODED FRAME and never from calling play(). This is the 2026-08-31
   *     iPhone-blink fix: iOS Safari discards the native poster the moment
   *     playback is requested and paints nothing until the first frame lands.
   *     A video that never starts keeps its poster; that is the degrade.
   */
  (() => {
    const motionQuery = window.matchMedia
      ? matchMedia('(prefers-reduced-motion: reduce)')
      : null;
    const reduced = () => (motionQuery ? motionQuery.matches : false);
    const fine = window.matchMedia ? matchMedia('(any-pointer: fine)').matches : false;

    /* The poster is retired by a DECODED FRAME, never by a call to play():
       requestVideoFrameCallback fires on presentation, and an advanced
       currentTime is the same guarantee one frame late where it is missing.
       Playback that never starts therefore leaves the poster standing. */
    const goLive = (video) => {
      const stage = video.closest('.mv-cross__stage');
      if (stage) stage.classList.add('is-live');
    };
    const armPoster = (video) => {
      if (video.dataset.mvArmed) return;
      video.dataset.mvArmed = 'true';
      if (typeof video.requestVideoFrameCallback === 'function') {
        video.requestVideoFrameCallback(() => goLive(video));
        return;
      }
      const onTime = () => {
        if (video.currentTime > 0) {
          video.removeEventListener('timeupdate', onTime);
          goLive(video);
        }
      };
      video.addEventListener('timeupdate', onTime);
    };
    /* Buffer as the card comes into view rather than at the play threshold.
       The poster covers the wait either way, but reaching 60% with nothing
       fetched leaves the stage still for the length of the first-frame
       request. Guarded on `paused` and on a readyState holding no frame, so
       load() can never interrupt a video that is already running. */
    const warm = (video) => {
      if (video && video.preload !== 'auto' && video.paused && video.readyState < 2) {
        video.preload = 'auto';
        video.load();
      }
    };
    const play = (video) => {
      if (!video || reduced()) return;
      warm(video);
      armPoster(video);
      const started = video.play();
      if (started && started.catch) started.catch(() => {});
    };
    const pause = (video) => {
      if (video && !video.paused) video.pause();
    };

    const observed = new Set();
    let observer = null;
    if (!fine && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            const video = entry.target.querySelector('.mv-cross__video');
            if (entry.intersectionRatio >= 0.6) play(video);
            else {
              if (entry.isIntersecting) warm(video);
              pause(video);
            }
          }
        },
        { threshold: [0, 0.6] }
      );
    }

    const boot = (scope) => {
      for (const card of (scope || document).querySelectorAll('.mv-cross__link--video')) {
        if (card.dataset.mvCrossReady) continue;
        card.dataset.mvCrossReady = 'true';
        if (fine) {
          card.addEventListener('mouseenter', () => play(card.querySelector('.mv-cross__video')));
          card.addEventListener('mouseleave', () => pause(card.querySelector('.mv-cross__video')));
        } else if (observer) {
          observer.observe(card);
          observed.add(card);
        }
      }
    };

    if (motionQuery) {
      const onMotionChange = () => {
        if (!motionQuery.matches) return;
        for (const video of document.querySelectorAll('.mv-cross__video')) pause(video);
      };
      if (motionQuery.addEventListener) motionQuery.addEventListener('change', onMotionChange);
      else if (motionQuery.addListener) motionQuery.addListener(onMotionChange);
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        for (const video of document.querySelectorAll('.mv-cross__video')) pause(video);
      } else if (observer) {
        for (const card of observed) {
          observer.unobserve(card);
          observer.observe(card);
        }
      }
    });

    boot();

    // Theme editor: the section is re-rendered wholesale, so the armed card is
    // replaced by an unarmed copy of itself. Drop the detached card from the
    // observer before the replacement registers, the way mv-hero drops a
    // disconnected slideshow instance.
    document.addEventListener('shopify:section:load', (event) => {
      for (const card of observed) {
        if (card.isConnected) continue;
        if (observer) observer.unobserve(card);
        observed.delete(card);
      }
      boot(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-faq"] && !Shopify.designMode) return;
  try {
    
  /**
   * Monovits FAQ — open the deep-linked answer.
   *
   * The homepage teaser links each question to `#faq-{handleized question}`,
   * which is a row wrapper here. Every row is a collapsed `<details>`, so the
   * anchor jump on its own lands the reader on a closed answer. A product row
   * additionally lives inside a panel that may not be the selected one, so the
   * panel is revealed first or the anchor scrolls to a hidden element.
   *
   * Timing: `accordion-custom` re-asserts its default open state inside
   * `connectedCallback`, which would close anything opened before the element
   * upgrades. So the load pass waits for the definition, then a frame. If the
   * definition never arrives the row stays closed and the anchor still scrolls
   * — degraded, not broken.
   *
   * Resize is deliberately left alone. `assets/accordion-custom.js` closes open
   * rows on every crossing of the 750px breakpoint, and that is shared vendor
   * behaviour; re-opening this one row afterwards would make the deep-linked
   * answer the only disclosure on the site that survives a resize.
   */
  (() => {
    const PREFIX = '#faq-';

    const openTargetRow = () => {
      const hash = window.location.hash;

      if (!hash || hash.indexOf(PREFIX) !== 0) return;

      let row = null;

      try {
        row = document.querySelector(hash);
      } catch (e) {
        return; /* Not a usable selector, so not one of our anchors. */
      }

      if (!row) return;

      const panel = row.closest('[data-mv-faq-panel]');
      const selector = panel && panel.closest('mv-faq-selector');

      if (panel && selector && typeof selector.selectHandle === 'function') {
        selector.selectHandle(panel.getAttribute('data-handle'), { announce: false });
      }

      const details = row.querySelector('details');

      if (details) details.open = true;
    };

    const openAfterUpgrade = () => {
      if (!window.customElements) {
        openTargetRow();
        return;
      }

      window.customElements
        .whenDefined('accordion-custom')
        .then(() => window.requestAnimationFrame(openTargetRow))
        .catch(() => openTargetRow());
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openAfterUpgrade, { once: true });
    } else {
      openAfterUpgrade();
    }

    window.addEventListener('hashchange', openTargetRow);
  })();

  /**
   * Monovits FAQ — the rail.
   *
   * Two jobs: pick which product panel is shown, and mark which question group
   * the reader is currently in.
   *
   * ORDER. The server renders block order, which is correct for everyone and
   * fully cacheable. This then moves the visitor's own products to the top:
   * purchased first (handles injected by Liquid for a signed-in customer), then
   * recently viewed (handles from `localStorage`), then whatever is left in
   * block order. It is silent by design — no badge, no "recommended for you",
   * nothing in the URL. It changes which bottle is first, nothing else, and a
   * first-time visitor sees plain block order.
   *
   * The reorder moves the `<li>`s in the DOM rather than painting positions, so
   * tab order and reading order stay identical to what is on screen.
   *
   * No arrow-key handling and no roving tabindex: every product is a plain
   * button in a short list, so Tab already reaches each one in visual order.
   * That is the behaviour a list of four to eight items wants.
   */
  (() => {
    if (!window.customElements || customElements.get('mv-faq-selector')) return;

    const VIEWED_KEY = 'mv:recently-viewed';

    class MvFaqSelector extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('.mv-faqnav');
        this.list = this.querySelector('[data-mv-faq-list]');
        this.panels = Array.from(this.querySelectorAll('[data-mv-faq-panel]'));
        this.cards = Array.from(this.querySelectorAll('[data-mv-faq-card]'));
        this.jumpLinks = Array.from(this.querySelectorAll('[data-mv-faq-jump]'));
        this.groups = Array.from(this.querySelectorAll('[data-mv-faq-group]'));

        this.bindJump();

        if (!this.list || this.cards.length === 0) return;

        this.status = this.ensureStatus();
        this.reorder();
        this.index = this.initialIndex();
        this.paint(false);
        this.bind();
      }

      disconnectedCallback() {
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      }

      /**
       * The live region is created here rather than in Liquid so it cannot be
       * reordered, translated or removed by a merchant edit — it is machinery,
       * not content.
       */
      ensureStatus() {
        const p = document.createElement('p');

        p.className = 'visually-hidden';
        /* A change of context, not an alert: announced politely, when the
           reader next pauses. */
        p.setAttribute('role', 'status');
        this.appendChild(p);

        return p;
      }

      /* ── Ordering ──────────────────────────────────────────────────────── */

      viewedHandles() {
        try {
          const raw = window.localStorage.getItem(VIEWED_KEY);
          const list = raw ? JSON.parse(raw) : [];

          return Array.isArray(list) ? list.filter((h) => typeof h === 'string') : [];
        } catch (e) {
          /* Private mode or disabled storage. No signal is a valid signal. */
          return [];
        }
      }

      purchasedHandles() {
        const raw = this.rail && this.rail.getAttribute('data-purchased');

        return raw ? raw.split(/\s+/).filter(Boolean) : [];
      }

      reorder() {
        const byHandle = new Map();

        this.cards.forEach((card) => {
          const item = card.closest('.mv-faqnav__item');
          const handle = card.getAttribute('data-handle');

          if (item && handle && !byHandle.has(handle)) byHandle.set(handle, item);
        });

        const ranked = [];
        const seen = new Set();

        const take = (handles) => {
          handles.forEach((handle) => {
            if (byHandle.has(handle) && !seen.has(handle)) {
              seen.add(handle);
              ranked.push(byHandle.get(handle));
            }
          });
        };

        take(this.purchasedHandles());
        take(this.viewedHandles());
        /* Everything not matched keeps its authored position. */
        take(Array.from(byHandle.keys()));

        ranked.forEach((item) => this.list.appendChild(item));

        this.cards = Array.from(this.querySelectorAll('[data-mv-faq-card]'));
      }

      initialIndex() {
        let requested = null;

        try {
          requested = new URLSearchParams(window.location.search).get('product');
        } catch (e) {
          requested = null;
        }

        if (requested) {
          const found = this.cards.findIndex(
            (card) => card.getAttribute('data-handle') === requested
          );

          if (found !== -1) return found;
        }

        return 0;
      }

      /* ── Painting ──────────────────────────────────────────────────────── */

      paint(announce) {
        const handle = this.cards[this.index].getAttribute('data-handle');

        this.cards.forEach((card, i) => {
          card.setAttribute('aria-pressed', i === this.index ? 'true' : 'false');
        });

        let title = '';

        this.panels.forEach((panel) => {
          const selected = panel.getAttribute('data-handle') === handle;

          panel.classList.toggle('is-selected', selected);

          if (selected) {
            const heading = panel.querySelector('.mv-faqpanels__title');

            title = heading ? heading.textContent.trim() : '';
          }
        });

        this.syncUrl(handle);

        if (!announce) return;

        if (this.status && title) this.status.textContent = title + ' questions shown.';

        this.revealOnNarrowScreens();
      }

      /**
       * `replaceState`, not `pushState`: switching between four bottles should
       * not bury the page the visitor arrived from under four back-button
       * presses. The URL still updates, so a selection stays copy-pasteable.
       */
      syncUrl(handle) {
        if (!window.history || !window.history.replaceState) return;

        try {
          const url = new URL(window.location.href);

          url.searchParams.set('product', handle);
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) {
          /* A URL the browser will not parse is not worth failing selection over. */
        }
      }

      /**
       * On a phone the rail sits above the answers, so a selection made at the
       * top would change content that is off-screen. On desktop the panel is
       * already beside the rail and moving the page under a click the visitor
       * just made is disorienting.
       */
      revealOnNarrowScreens() {
        if (!window.matchMedia || !window.matchMedia('(max-width: 989px)').matches) return;

        const panel = this.panels.find((p) => p.classList.contains('is-selected'));

        if (!panel) return;

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        panel.scrollIntoView({ block: 'start', behavior: reduced ? 'auto' : 'smooth' });
      }

      /* ── Interaction ───────────────────────────────────────────────────── */

      select(index, options) {
        const total = this.cards.length;

        this.index = ((index % total) + total) % total;
        this.paint(!options || options.announce !== false);
      }

      /** Public: used by the `#faq-` deep-link opener to reveal a hidden row. */
      selectHandle(handle, options) {
        const found = this.cards.findIndex(
          (card) => card.getAttribute('data-handle') === handle
        );

        if (found !== -1) this.select(found, options);
      }

      bind() {
        this.cards.forEach((card, i) => {
          card.addEventListener('click', () => this.select(i));
        });
      }

      /**
       * Marks which group the reader is in. Reads positions on a rAF-throttled
       * scroll rather than using IntersectionObserver: "the heading nearest the
       * top of the viewport" is a comparison across all headings at one moment,
       * which is awkward to express as per-element intersection callbacks and
       * easy to express as one pass over their rects.
       */
      bindJump() {
        if (this.jumpLinks.length === 0 || this.groups.length === 0) return;

        let queued = false;

        const update = () => {
          queued = false;

          const line = window.innerHeight * 0.25;
          let currentId = null;

          this.groups.forEach((group) => {
            if (group.getBoundingClientRect().top <= line && group.id) currentId = group.id;
          });

          /* The last group can never cross the line: the page runs out of
             scroll before its heading reaches a quarter of the way up, so it
             would be the one entry the rail could never mark. At the bottom of
             the document, the last group is by definition what you are reading. */
          const atBottom =
            window.innerHeight + window.scrollY >=
            document.documentElement.scrollHeight - 2;

          if (atBottom) {
            for (let i = this.groups.length - 1; i >= 0; i -= 1) {
              if (this.groups[i].id) {
                currentId = this.groups[i].id;
                break;
              }
            }
          }

          this.jumpLinks.forEach((link) => {
            const active = currentId !== null && link.hash === '#' + currentId;

            if (active) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
        };

        this.onScroll = () => {
          if (queued) return;
          queued = true;
          window.requestAnimationFrame(update);
        };

        window.addEventListener('scroll', this.onScroll, { passive: true });
        update();
      }
    }

    customElements.define('mv-faq-selector', MvFaqSelector);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-product-details"]) return;
  try {
    
  /**
   * Fragment links into collapsed disclosures.
   *
   * A fragment can land on an element sitting inside a `<details>` the visitor
   * has not opened — and since 2026-09-02 all four disclosures here are closed
   * on load, so that is now the normal case rather than the edge one. A browser
   * will not scroll to a target it cannot lay out, and in-page find will not
   * match text inside a closed `<details>` on engines without
   * `hidden=until-found`. This opens every ancestor disclosure of the fragment
   * target, then scrolls to it.
   *
   * The buy box used to carry a "View full Supplement Facts" link into this
   * section; it was deleted on 2026-09-02 and NOTHING IN THE THEME links here
   * any more — verified across every `.liquid` and `.json`. This script is kept
   * because inbound fragments can still arrive from outside the theme (an Admin
   * page body, an email, an external link), and `anchor_id` is still emitted.
   *
   * Convenience only. `<details>` is natively functional with JavaScript off:
   * the content is in the served HTML, the summary still toggles, and the
   * anchor still moves the browser to the region — this only saves the visitor
   * the click.
   *
   * Everything below is inside an IIFE. Shopify concatenates every section's
   * javascript block into a single bundle sharing one global scope, so a
   * top-level `const` or `function` here is a global for the whole site: a
   * second section declaring the same name is a SyntaxError that takes the
   * entire bundle down, not just this section.
   */
  (function () {
    function revealHashTarget() {
      const hash = window.location.hash;
      // `#` alone, and `#` with nothing after it, name no target.
      if (!hash || hash.length < 2) return;

      // A fragment identifier is not required to be a valid CSS selector —
      // `#2024-notes` and `#a b` are both legal in a URL and both throw here.
      let target = null;
      try {
        target = document.querySelector(hash);
      } catch (error) {
        return;
      }
      if (!target) return;

      // THE SKIP LINK IS WHY THIS GUARD EXISTS — do not "simplify" it away.
      // `layout/theme.liquid` renders a "Skip to main content" link pointing at
      // `#MainContent`, the `<main>` that CONTAINS this section. Activating it
      // fires `hashchange` with a target whose descendants are every disclosure
      // on the page, so without this bail the keyboard or screen-reader user who
      // takes the skip link — the one person who depends on it — gets all four
      // panels forced open and a smooth scroll racing the browser's own focus
      // jump. Only a fragment inside this section is ours to act on.
      if (!target.closest('.mv-pdp-details')) return;

      // Walk outwards: a disclosure can be nested inside another one, and
      // opening only the innermost would leave the target still unrendered.
      let details = target.closest('details');
      while (details) {
        details.open = true;
        const parent = details.parentElement;
        details = parent ? parent.closest('details') : null;
      }

      // And inwards, for a fragment that resolves to a wrapper CONTAINING a
      // disclosure rather than to something inside one — `closest` finds nothing
      // there. `mv-supplement-facts` now carries its `anchor_id` on the
      // `<details>` itself, so the ancestor walk handles `#supplement-facts`;
      // this covers a merchant-set `anchor_id` on a non-collapsible block and
      // any future block that anchors its wrapper.
      //
      // Scoped to `details.mv-disclosure`, not every `<details>`: a bare
      // descendant query would also force open any theme or app disclosure that
      // happens to sit under the target.
      for (const nested of target.querySelectorAll('details.mv-disclosure')) {
        nested.open = true;
      }

      // Read the motion preference at call time, not at load: a visitor who
      // changes it mid-session gets the current answer.
      const reduced =
        typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    }

    window.addEventListener('hashchange', revealHashTarget);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', revealHashTarget, { once: true });
    } else {
      revealHashTarget();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-product-main"]) return;
  try {
    
  /**
   * PDP gallery and buy column — progressive enhancement only.
   *
   * Without this script the thumbnails are plain in-page anchors, every image
   * is already in the DOM at final state, and the buy column is sticky at
   * every desktop viewport. The gallery is complete and navigable with
   * JavaScript off. What this adds:
   *
   *   1. The selected thumbnail tracks the visible image, via `aria-current`,
   *      and is scrolled into view inside its own strip.
   *   2. A click scrolls the carousel itself rather than letting the browser
   *      jump the page to the fragment.
   *   3. `replaceState`, never `pushState` — a gallery is one destination, and
   *      one history entry per thumbnail turns Back into a trap.
   *   4. The list drops its `tabindex` — and its "scrollable" label — from
   *      990px up, where it is a stack rather than a scroller and therefore
   *      neither a keyboard stop nor scrollable.
   *   5. The buy column's measured height is published as `--mv-buy-h`, which
   *      is what lets the CSS clamp its sticky offset so a column taller than
   *      the viewport pins by its BOTTOM edge instead of burying its tail.
   *
   * Everything below is inside an IIFE. Shopify concatenates every section's
   * javascript block into a single bundle sharing one global scope, so a
   * top-level `const` or `function` here is a global for the whole site: a
   * second section declaring the same name is a SyntaxError that takes the
   * entire bundle down, not just this section. Nothing in this file is called
   * from outside it, so nothing needs to leak.
   */
  (function () {
    // Matches the CSS breakpoint. One query object, read at call time rather
    // than sampled at load, so a resize or an orientation change is answered
    // with the truth rather than with whatever was true at page load.
    const desktopQuery = typeof window.matchMedia === 'function' ? window.matchMedia('(min-width: 990px)') : null;

    function isDesktop() {
      return desktopQuery ? desktopQuery.matches : false;
    }

    // Read at call time, not at load. A visitor who changes their motion
    // preference mid-session — an OS-level toggle, no reload — would otherwise
    // keep whatever was true when the page loaded.
    const motionQuery =
      typeof window.matchMedia === 'function' ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function prefersReducedMotion() {
      return motionQuery ? motionQuery.matches : false;
    }

    /**
     * Moves `aria-current`, then keeps the newly-current thumbnail inside the
     * strip's own scroll window. The strip is a horizontal scroller carrying
     * up to eight 64px tiles, so on a phone the thumbnail matching the visible
     * slide is routinely off the end of it; without this, swiping the carousel
     * moves a selection the visitor cannot see.
     *
     * THIS SCROLLS THE STRIP ITSELF AND MUST NOT GO BACK TO `scrollIntoView`.
     *
     * `scrollIntoView({ block: 'nearest' })` was tried and is wrong here.
     * `nearest` does not mean "leave the block axis alone" — per CSSOM-View the
     * method walks EVERY scrolling ancestor, the document included, and scrolls
     * minimally on any axis where the element is not already fully visible. So
     * on a phone with the strip straddling the fold, each swipe fired a smooth
     * document scroll under the visitor's thumb, and the observer's first
     * callback — which runs at load, since slide 1 starts at ratio 1 — moved
     * the page before the visitor had touched anything.
     *
     * Writing `scrollLeft` on the strip cannot move the page: it is one
     * element's own scroll offset, with no ancestor walk. The arithmetic keeps
     * the tile inside the visible window by the shortest distance, which is
     * what 'nearest' was wanted for in the first place.
     *
     * From 990px up the strip is `display: none`, so `clientWidth` is 0 and the
     * early return below makes the call inert there rather than needing a
     * breakpoint guard — the same reason the observer is left running.
     */
    function setCurrent(thumbs, active) {
      for (const thumb of thumbs) {
        if (thumb === active) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      }

      if (!active) return;
      const strip = active.closest('.mv-stage__thumb-list');
      if (!strip || !strip.clientWidth) return;

      // `offsetLeft` is relative to the nearest positioned ancestor. The strip
      // is not positioned, so read the geometry off the rects instead and work
      // entirely in the strip's own scroll coordinates.
      const stripBox = strip.getBoundingClientRect();
      const tileBox = active.getBoundingClientRect();
      const tileStart = tileBox.left - stripBox.left + strip.scrollLeft;
      const tileEnd = tileStart + tileBox.width;

      let target = strip.scrollLeft;
      if (tileStart < strip.scrollLeft) {
        target = tileStart;
      } else if (tileEnd > strip.scrollLeft + strip.clientWidth) {
        target = tileEnd - strip.clientWidth;
      } else {
        // Already fully inside the window — the 'nearest' no-op case.
        return;
      }

      if (typeof strip.scrollTo === 'function') {
        strip.scrollTo({ left: target, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      } else {
        strip.scrollLeft = target;
      }
    }

    const galleryCleanup = new Map();
    const pdpCleanup = new Map();
    function initGallery(stage) {
      if (galleryCleanup.has(stage)) return;
      const events = new AbortController();
      let observer;
      galleryCleanup.set(stage, () => { events.abort(); observer?.disconnect(); });
      const viewport = stage.querySelector('[data-mv-gallery]');
      // `data-mv-dot` is the hook, unchanged: it is the index contract between
      // the markup and this function, and the class around it moving from dot
      // to thumbnail does not change what the attribute means.
      const thumbs = stage.querySelectorAll('[data-mv-dot]');
      if (!viewport || thumbs.length < 2) return;

      const byIndex = new Map();
      for (const thumb of thumbs) byIndex.set(thumb.dataset.mvDot, thumb);

      for (const thumb of thumbs) {
        thumb.addEventListener('click', (event) => {
          const target = document.getElementById(decodeURIComponent(thumb.hash.slice(1)));
          if (!target) return;
          event.preventDefault();
          viewport.scrollTo({
            left: target.offsetLeft,
            behavior: prefersReducedMotion() ? 'auto' : 'smooth',
          });
          setCurrent(thumbs, thumb);
          history.replaceState(history.state, '', thumb.hash);
        }, { signal: events.signal });
      }

      // Keeps the selected thumbnail honest when the carousel is swiped or
      // scrolled by keyboard rather than clicked.
      //
      // The observer is left running at desktop widths on purpose. There the
      // list is not a scroller, so every item reports fully inside the root at
      // once and `aria-current` settles on the last of them — which is
      // invisible and unannounced, because the thumbnail strip is
      // `display: none` and therefore out of the accessibility tree entirely.
      // Tearing the observer down and rebuilding it on every breakpoint
      // crossing costs more code than the state it would tidy.
      if (typeof IntersectionObserver !== 'function') return;
      const items = viewport.querySelectorAll('[id]');
      observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.intersectionRatio < 0.6) continue;
            const index = String([].indexOf.call(items, entry.target) + 1);
            const thumb = byIndex.get(index);
            if (thumb) setCurrent(thumbs, thumb);
          }
        },
        { root: viewport, threshold: 0.6 }
      );
      for (const item of items) observer.observe(item);
    }

    /**
     * The list is a horizontal scroll container below 990px and a plain stack
     * above it. WCAG 2.1.1 requires the tab stop in the first case and nothing
     * requires it in the second, where it is a stop that does nothing.
     *
     * The accessible name moves with it. "scrollable" describes an affordance
     * that only exists below 990px; announcing it over a static stack sends a
     * screen-reader user looking for a scroll that is not there. Both strings
     * come from `data-` attributes escaped by Liquid, so no product title is
     * ever assembled in JS. If either attribute is missing the label is left
     * exactly as the server rendered it.
     */
    function syncViewportFocus(viewport) {
      const desktop = isDesktop();
      if (desktop) viewport.removeAttribute('tabindex');
      else viewport.setAttribute('tabindex', '0');

      const label = desktop ? viewport.dataset.mvLabelDesktop : viewport.dataset.mvLabelMobile;
      if (label) viewport.setAttribute('aria-label', label);
    }

    /**
     * Publishes the buy column's height as `--mv-buy-h`.
     *
     * That is the whole job. The DECISION lives in CSS: the sticky `top` is
     * `min(--mv-sticky-top, 100svh - --mv-buy-h - --mv-space-6)`, so a column
     * that fits pins under the header and a column that does not pins by its
     * bottom edge, one space token above the fold. Nothing here reads
     * `getComputedStyle`, nothing toggles an attribute, and no pixel figure is
     * duplicated out of the stylesheet — the head and foot clearances are both
     * `--mv-space-6`, stated once, in the rule that uses them.
     *
     * `offsetHeight` is the right measure and is unaffected by the positioning:
     * sticky does not change layout height. Writing the property cannot feed
     * back into the observer either, since only `top` depends on it.
     *
     * Written at every width. It is read only from 990px up, and recomputing
     * on the way across the breakpoint is what `sync` already does.
     */
    function syncBuyHeight(column) {
      column.style.setProperty('--mv-buy-h', column.offsetHeight + 'px');
    }

    function initPdp(pdp) {
      if (pdpCleanup.has(pdp)) return;
      const events = new AbortController();
      let resizeObserver;
      let frame = 0;
      pdpCleanup.set(pdp, () => { events.abort(); resizeObserver?.disconnect(); cancelAnimationFrame(frame); });
      const viewport = pdp.querySelector('[data-mv-gallery]');
      const column = pdp.querySelector('[data-mv-buy]');

      // Collapsed into one frame: a resize fires continuously, and both jobs
      // below force layout.
      let queued = false;
      const sync = () => {
        if (queued) return;
        queued = true;
        frame = requestAnimationFrame(() => {
          queued = false;
          if (viewport) syncViewportFocus(viewport);
          if (column) syncBuyHeight(column);
        });
      };

      sync();
      addEventListener('resize', sync, { signal: events.signal, passive: true });

      // The column's own height moves independently of the viewport — a font
      // swap, a variant change, an app block rendering late. Without this the
      // published height would be right only for the height the column happened
      // to have at load.
      if (column && typeof ResizeObserver === 'function') { resizeObserver = new ResizeObserver(sync); resizeObserver.observe(column); }
    }

    function initAll() {
      for (const stage of document.querySelectorAll('.mv-stage')) initGallery(stage);
      for (const pdp of document.querySelectorAll('[data-mv-pdp]')) initPdp(pdp);
    }

    const cleanup = (scope) => {
      for (const registry of [galleryCleanup, pdpCleanup]) for (const [element, dispose] of registry) {
        if (scope === document || scope === element || scope.contains(element)) { dispose(); registry.delete(element); }
      }
    };
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:section:unload', event => cleanup(event.target));
    addEventListener('pagehide', () => cleanup(document));
    addEventListener('pageshow', event => { if (event.persisted) initAll(); });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();

  /**
   * Fragment links into collapsed disclosures.
   *
   * MOVED HERE FROM `sections/mv-product-details.liquid` on 2026-09-02, when the
   * owner moved the four disclosures into the buy column and that section left
   * the product template. Shopify only bundles the JavaScript of sections that
   * actually render, so leaving this behind would have silently killed every
   * deep link into `#supplement-facts` — the anchor would land on a panel that
   * never opens. The section file still exists, unused; it is NOT the live copy
   * of this behaviour any more.
   *
   * All four disclosures load closed (owner, 2026-09-02), so a fragment landing
   * on one is the normal case, not the edge one. A browser will not scroll to a
   * target it cannot lay out, and in-page find will not match text inside a
   * closed `<details>` on engines without `hidden=until-found`.
   *
   * Convenience only. `<details>` is natively functional with JavaScript off.
   */
  (function () {
    function revealFragmentInBuyColumn() {
      const hash = window.location.hash;
      if (!hash || hash.length < 2) return;

      // A fragment identifier need not be a valid CSS selector — `#2024-notes`
      // is legal in a URL and throws here.
      let target = null;
      try {
        target = document.querySelector(hash);
      } catch (error) {
        return;
      }
      if (!target) return;

      // THE SKIP LINK IS WHY THIS GUARD EXISTS. `layout/theme.liquid` renders a
      // "Skip to main content" link pointing at `#MainContent`, which CONTAINS
      // this column; without the bail, taking that link would force every panel
      // open and race a smooth scroll against the browser's own focus jump —
      // for the one visitor who depends on the skip link. Scope changed from
      // `.mv-pdp-details` to the buy column when the blocks moved.
      if (!target.closest('.mv-pdp__details-col')) return;

      let details = target.closest('details');
      while (details) {
        details.open = true;
        const parent = details.parentElement;
        details = parent ? parent.closest('details') : null;
      }

      // And inwards, for a fragment resolving to a wrapper that CONTAINS a
      // disclosure rather than to something inside one.
      for (const nested of target.querySelectorAll('details.mv-disclosure')) {
        nested.open = true;
      }

      const reduced =
        typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    }

    window.addEventListener('hashchange', revealFragmentInBuyColumn);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', revealFragmentInBuyColumn, { once: true });
    } else {
      revealFragmentInBuyColumn();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-trust-badges"] && !Shopify.designMode) return;
  try {
    
  /**
   * Monovits golden trust badges — sheen.
   *
   * Two modes, one set of maths:
   *   pointer  (hover-capable) — each badge is lit from the side OPPOSITE the
   *            cursor. Per-badge on purpose: a point light near the cursor
   *            genuinely does hit three coplanar medallions from three
   *            slightly different angles, and that is what sells the depth.
   *   scroll   (touch) — ONE shared direction for all three badges, recomputed
   *            as the row travels past a virtual light. See below for why this
   *            one must not be per-badge.
   *
   * Contract:
   *   - Every value written is a lighting value: a translate on an absolutely
   *     positioned overlay, a rotate on a masked ring, an SVG transform on a
   *     gradient circle, and a box-shadow. Nothing here can move layout.
   *   - The markup ships the static top-lit state. This only overrides it, so a
   *     parse failure or JS-off visitor still sees three finished badges.
   *   - Under `prefers-reduced-motion: reduce` no listener is attached and any
   *     values already written are cleared back to the CSS default.
   */
  (() => {
    const SPREAD = 0.4;
    const SHEEN = 1;

    /* Virtual light for scroll mode, in viewport fractions. Deliberately OFF
       to the upper right rather than centred: a light directly overhead gives
       `dx === 0`, and `atan2` then snaps between +90 and -90 as the row crosses
       it instead of sweeping. Upper-right also matches the warm key light in
       the brand imagery. */
    const LIGHT_X = 0.86;
    const LIGHT_Y = 0.12;

    const motionQuery = window.matchMedia
      ? matchMedia('(prefers-reduced-motion: reduce)')
      : null;

    /* Touch devices never fire `pointermove` on idle. Gated on `(hover: none)`
       rather than a width breakpoint, because the input device decides this,
       not the viewport — a narrow desktop window still has a pointer to track,
       and a large tablet still does not. */
    const touchQuery = window.matchMedia ? matchMedia('(hover: none)') : null;
    const isTouch = () => !!(touchQuery && touchQuery.matches);

    const groups = Array.from(document.querySelectorAll('[data-mv-goldbadges]'))
      .map((root) => ({
        root,
        list: root.querySelector('.mv-goldbadges__list') || root,
        visible: false,
        radius: 0,
        badges: Array.from(root.querySelectorAll('[data-mv-badge]')).map((el) => ({
          el,
          light: el.querySelector('[data-mv-core-light]'),
          shade: el.querySelector('[data-mv-core-shade]'),
          last: {},
        })),
      }))
      .filter((g) => g.badges.length);

    if (!groups.length) return;

    let pointerX = null;
    let pointerY = null;
    let frame = null;
    let attached = false;

    /* All badges are the same size, so the radius is measured once per group
       and cached. In scroll mode this leaves exactly ONE layout read per frame
       (the row's rect) instead of one per badge. */
    const measure = () => {
      groups.forEach((g) => {
        const first = g.badges[0].el;
        g.radius = first.offsetWidth / 2;
      });
    };

    /* Writes are the expensive half: each custom property invalidates style on
       an element whose overlays carry `mix-blend-mode` and a radial mask, and
       those repaint rather than composite. Values are quantised to whole pixels
       and tenths of a degree, then compared against the last write, so a scroll
       that does not visibly change the lighting costs nothing at all. */
    const put = (b, key, prop, value) => {
      if (b.last[key] === value) return;
      b.last[key] = value;
      b.el.style.setProperty(prop, value);
    };

    const putAttr = (b, key, node, value) => {
      if (!node || b.last[key] === value) return;
      b.last[key] = value;
      node.setAttribute('transform', value);
    };

    const apply = (b, rx, ry, radius) => {
      const offset = radius * SPREAD;
      put(b, 'hi', '--mv-gb-hi',
        'translate(' + (rx * offset).toFixed(0) + 'px, ' + (ry * offset).toFixed(0) + 'px)');
      put(b, 'shd', '--mv-gb-shd',
        'translate(' + (-rx * offset * 0.85).toFixed(0) + 'px, ' + (-ry * offset * 0.85).toFixed(0) + 'px)');
      put(b, 'ring', '--mv-gb-ring',
        'rotate(' + ((Math.atan2(ry, rx) * 180) / Math.PI + 62).toFixed(1) + 'deg)');
      put(b, 'glow', '--mv-gb-glow',
        (rx * 8).toFixed(0) + 'px ' + (ry * 8).toFixed(0) + 'px 22px -8px rgba(255,199,113,' + (0.13 * SHEEN).toFixed(2) + ')');

      // Inner emblem is lit in the SVG's own 400x400 user space — viewBox units,
      // which do not scale with the rendered badge.
      putAttr(b, 'lightT', b.light,
        'translate(' + (rx * 78).toFixed(0) + ',' + (ry * 78).toFixed(0) + ')');
      putAttr(b, 'shadeT', b.shade,
        'translate(' + (-rx * 66).toFixed(0) + ',' + (-ry * 66).toFixed(0) + ')');
    };

    const paint = () => {
      frame = null;
      const touch = isTouch();
      if (!touch && pointerX === null) return;

      groups.forEach((g) => {
        if (!g.visible) return;

        if (touch) {
          /* ONE shared direction for the whole row.
             Measuring each badge separately against the light is correct for a
             cursor but wrong here: the badges sit side by side, so the left one
             would see a negative dx and the right one a positive dx, and the
             two would light up as mirror images of each other. Three medallions
             lying flat on the same surface under one distant light must all
             show the SAME reflection — mirrored highlights read as three
             unrelated objects, not one row of metal. The row's centre supplies
             that single vector. */
          const r = g.list.getBoundingClientRect();
          if (!r.width) return;
          const dx = r.left + r.width / 2 - window.innerWidth * LIGHT_X;
          const dy = r.top + r.height / 2 - window.innerHeight * LIGHT_Y;
          const len = Math.hypot(dx, dy) || 1;
          const rx = -dx / len;
          const ry = -dy / len;
          const radius = g.radius || g.badges[0].el.offsetWidth / 2;
          g.badges.forEach((b) => apply(b, rx, ry, radius));
          return;
        }

        g.badges.forEach((b) => {
          const box = b.el.getBoundingClientRect();
          if (!box.width) return;
          const radius = box.width / 2;
          const dx = pointerX - (box.left + radius);
          const dy = pointerY - (box.top + box.height / 2);
          const len = Math.hypot(dx, dy) || 1;
          apply(b, -dx / len, -dy / len, radius);
        });
      });
    };

    const request = () => {
      if (frame === null) frame = requestAnimationFrame(paint);
    };

    const anyVisible = () => groups.some((g) => g.visible);

    const onMove = (event) => {
      if (!anyVisible()) return;
      pointerX = event.clientX;
      pointerY = event.clientY;
      request();
    };

    /* The single biggest cost this script can impose is doing blend-mode and
       mask repaints on every scroll frame of a long page while the badges are
       nowhere near the viewport. Gating on intersection means scrolling the
       rest of the site costs one early return. */
    const onScroll = () => {
      if (anyVisible()) request();
    };

    const onResize = () => {
      measure();
      if (anyVisible()) request();
    };

    const observer = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const g = groups.find((x) => x.root === entry.target);
            if (g) g.visible = entry.isIntersecting;
          });
          if (anyVisible()) request();
        }, { rootMargin: '150px 0px' })
      : null;

    if (observer) groups.forEach((g) => observer.observe(g.root));
    else groups.forEach((g) => { g.visible = true; });

    const clear = (b) => {
      b.last = {};
      b.el.style.removeProperty('--mv-gb-hi');
      b.el.style.removeProperty('--mv-gb-shd');
      b.el.style.removeProperty('--mv-gb-ring');
      b.el.style.removeProperty('--mv-gb-glow');
      if (b.light) b.light.setAttribute('transform', 'translate(0,-78)');
      if (b.shade) b.shade.setAttribute('transform', 'translate(0,66)');
    };

    const attach = () => {
      if (attached) return;
      attached = true;
      measure();
      if (isTouch()) {
        window.addEventListener('scroll', onScroll, { passive: true });
      } else {
        window.addEventListener('pointermove', onMove, { passive: true });
      }
      window.addEventListener('resize', onResize, { passive: true });
      request();
    };

    const detach = () => {
      if (!attached) return;
      attached = false;
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      if (frame !== null) {
        cancelAnimationFrame(frame);
        frame = null;
      }
      pointerX = null;
      pointerY = null;
      groups.forEach((g) => g.badges.forEach(clear));
    };

    const sync = () => {
      if (motionQuery && motionQuery.matches) detach();
      else attach();
    };

    /* Attaching a mouse to a tablet flips `(hover: none)` live, and the wrong
       listener would stay bound. */
    if (touchQuery) {
      const reattach = () => { detach(); sync(); };
      if (touchQuery.addEventListener) touchQuery.addEventListener('change', reattach);
      else if (touchQuery.addListener) touchQuery.addListener(reattach);
    }

    sync();
    if (motionQuery) {
      if (motionQuery.addEventListener) motionQuery.addEventListener('change', sync);
      else if (motionQuery.addListener) motionQuery.addListener(sync);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
